<template>
  <div class="mt-4 flex justify-between">
    <h2 class="text-xl font-semibold leading-tight text-gray-800 dark:text-gray-200">
      <slot />
    </h2>

    <div><slot name="actions" /></div>
  </div>
</template>
